export const SKILLS = [
    {
        title: 'Frontend',
        icon: './assets/images/frontendIcon.png',
        skills: [
            { skill: "HTML5", percentage: "80%" },
            { skill: "CSS", percentage: "60%" },
            { skill: "JavaScript", percentage: "55%" },
            { skill: "Angular", percentage: "50%" },
        ],
    },
    {
        title: 'Backend',
        icon: './assets/images/backendIcon.png',
        skills: [
            { skill: "Java", percentage: "60%" },
            { skill: "PHP", percentage: "40%" },
            { skill: "Nest.js", percentage: "45%" },
            { skill: "Spring Boot", percentage: "50%" },
        ],
    },
    {
        title: 'Tools',
        icon: './assets/images/toolsIcon.png',
        skills: [
            { skill: "Git", percentage: "50%" },
            { skill: "Github & GitLab", percentage: "54%" },
            { skill: "GitHub Actions", percentage: "40%" },
            { skill: "SonarQube", percentage: "35%" },
            { skill: "Postman", percentage: "70%" },
            { skill: "Visual Studio Code", percentage: "60%" },
            { skill: "Netbeans", percentage: "60%" },
        ],
    },
    {
        title: 'Bases de Datos',
        icon: './assets/images/cursosIcon.png',
        skills: [
            { skill: "SQL Server", percentage: "60%" },
            { skill: "PostgreSQL", percentage: "55%" },
            { skill: "MySQL", percentage: "65%" },
        ],
    },
];